import { memoize } from './utils/js_utils';
export var isFirefox = memoize(function () {
  return /firefox/i.test(navigator.userAgent);
});
export var isSafari = memoize(function () {
  return Boolean(window.safari);
});


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/dist/esm/BrowserDetector.js
// module id = 341
// module chunks = 4